import { Injectable, signal } from '@angular/core';
import { PromotionDto } from '../../dto';

@Injectable({
  providedIn: 'root',
})
export class PromotionsService {
  private promotions: PromotionDto[] = [];

  selectedPackageId = signal<number | null>(null);

  setPromotions(promotions: PromotionDto[]) {
    this.promotions = promotions;
  }

  // promotion is alleen geldig op package Id
  getPackagePromotions(packageId: number) {
    return this.promotions.find((promotion) => promotion.packageId === packageId) ?? null;
  }

  // Get promotion by packageOptionId
  getPackageOptionDiscount(packageOptionId: number) {
    const packageId = this.selectedPackageId();
    if (!packageId || !packageOptionId) {
      return null;
    }
    const discounts = this.getPackagePromotions(packageId)?.discounts;
    return discounts?.find((discount) => discount?.packageOption?.id === packageOptionId) ?? null;
  }

  getDiscount(packageId: number, optionId: number) {
    return this.getPackagePromotions(packageId)?.discounts?.find((discount) => discount.discountType === 'package discount') ?? null;
  }
}
